import { fastSerialize } from "./serialize";

export const isEqual = <T>(a: T, b: T): boolean => {
	if (a === b) {
		return true;
	}

	if (a === null || b === null || a === undefined || b === undefined) {
		return a === b;
	}

	if (typeof a !== typeof b) {
		return false;
	}

	if (typeof a === "object") {
		try {
			return fastSerialize(a) === fastSerialize(b);
		} catch {
			return false;
		}
	}

	return a === b;
};
